document.addEventListener('DOMContentLoaded', () => {
  const sliderPanes = document.querySelectorAll('.media-slider__slider-pane');

  sliderPanes.forEach((pane) => {
    const track = pane.querySelector('.media-slider__slides');
    const dots = pane.querySelector('.media-slider__dots');

    if (!track || typeof window.themeCarousel !== 'function') return;

    const { mediaSliderAutoplay, mediaSliderSpeed } = pane.dataset;
    const autoplay = mediaSliderAutoplay === 'true';

    window.themeCarousel(track, {
      cellSelector: '.media-slider__slide',
      loop: true,
      equalHeight: false,
      pagination: { el: dots },
      autoplay: autoplay
        ? { delay: Number(mediaSliderSpeed) || 5000, disableOnInteraction: false }
        : false
    });
  });
});
